export const FIRM_DOCUMENT_FOLDER_CREATE_DIALOG_TEST_IDS = {
  cancelButton: 'firm-documents-folder-create-cancel',
  closeButton: 'firm-documents-folder-create-close',
  companyMenu: 'firm-documents-folder-create-company-menu',
  companyOption: (id: number) => `firm-documents-folder-create-company-${id}`,
  companySearch: 'firm-documents-folder-create-company-search',
  companySelect: 'firm-documents-folder-create-company-select',
  confirmButton: 'firm-documents-folder-create-confirm',
  dialog: 'firm-documents-folder-create-dialog',
  input: 'firm-documents-folder-create-input',
  parentFolderMenu: 'firm-documents-folder-create-parent-folder-menu',
  parentFolderOption: (id: number | null) => `firm-documents-folder-create-parent-folder-${id ?? 'root'}`,
  parentFolderSearch: 'firm-documents-folder-create-parent-folder-search',
  parentFolderSelect: 'firm-documents-folder-create-parent-folder-select',
} as const;
